import { render, staticRenderFns } from "./FinishSetup.vue?vue&type=template&id=1039f398&scoped=true&"
import script from "./FinishSetup.vue?vue&type=script&lang=js&"
export * from "./FinishSetup.vue?vue&type=script&lang=js&"
import style0 from "./FinishSetup.vue?vue&type=style&index=0&id=1039f398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1039f398",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1039f398')) {
      api.createRecord('1039f398', component.options)
    } else {
      api.reload('1039f398', component.options)
    }
    module.hot.accept("./FinishSetup.vue?vue&type=template&id=1039f398&scoped=true&", function () {
      api.rerender('1039f398', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/FinishSetup.vue"
export default component.exports